<template>
    <div class="event">
      <div class="pay">
        <form class="app-pay-form validate-form" @submit.prevent="$parent.withdrawal()">
            <div class="content">
                <div class="form-group">
                    <div class="alert alert-success">
                        Mailinize kod gönderildi ! Güvenliğiniz açısından mailinize gelen onay kodunu lütfen aşağıdaki kısıma yazınız
                    </div>
                </div>
                <div class="form-group">
                    <label>Mailinize Gelen Kodu Giriniz</label>
                    <div class="otp-input">
                        <input 
                        v-for="(value, index) in otp" 
                        :key="index" 
                        type="text" 
                        maxlength="1" 
                        v-model="otp[index]" 
                        @input="moveToNext(index)" 
                        ref="otpInput"
                        />
                    </div>
                </div>
                <div class="remaining">
                    <span>Kalan Süre: <b>{{ timerCount }}</b></span>
                </div>
                <div class="form-group">
                  <ButtonLoader class="primary block" :loader="$parent.btnLoading" :text="'Çekimi Gerçekleştir'" />
                </div>
            </div>
        </form>
      </div>
    </div>
  </template>
  
<script>
  export default {
    props:['form'],
    data() {
      return {
        otp: ['', '', '', '', '', ''],
        timerCount: 180,
      };
    },
    created(){
        this.runTimer();
    },
    methods: {
      moveToNext(index) {
        if (this.otp[index].length === 1 && index < this.otp.length - 1) {
          this.$refs.otpInput[index + 1].focus();
        }
        // Eğer son input dolmuşsa, tüm OTP kodlarını konsola yazdır
        if (index === this.otp.length - 1 && this.otp[index].length === 1) {
          this.$parent.form.withdraw_validation_code = this.otp.join('');
          this.$parent.withdrawal();
        }
      },
      runTimer(){
        if (this.timerCount > 0) {
            setTimeout(() => {
                this.timerCount--;
                this.runTimer();
            }, 1000);
        }else{
          window.location.reload();
        }
        
      },
    },
  };
</script>
  
<style lang="scss">
  
  #app:not(.mobile) .user-content-inc .pay .app-pay-form.validate-form .content{
    width: 50%;
  }
  
  .user-content-inc .pay .app-pay-form.validate-form {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .otp-input {
        display: flex;
        input {
            width: 100%;
            height: 50px;
            text-align: center;
            margin: 0 10px 0 00px;
            background: #ffffff1c !important;
            color: #fff !important;
            border: 2px solid #ffffff0d !important;
            font-size: 14px;
            padding: 0px !important;
            border-radius: 10px !important;
        }
    }
    .remaining{
        font-size: 14px;
        text-align: center;
        font-weight: bold;
        display: flex;
        margin: 10px 0;
        flex-direction: column;
        a{
            color: var(--client-c3);
        }
    }
    .button{
    }
  }
  </style>